import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';
import AgentReports from './AgentReports.vue';
import LabelReports from './LabelReports.vue';
import InboxReports from './InboxReports.vue';
import TeamReports from './TeamReports.vue';
import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';
import CommissionReports from './CommissionReports.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'commission',
          name: 'commission_reports',
          meta: {
            permissions: ['administrator', 'agent', 'report_manage'],
          },
          component: CommissionReports,
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: Index,
        },
        {
          path: 'agent',
          name: 'agent_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: AgentReports,
        },
        {
          path: 'label',
          name: 'label_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: LabelReports,
        },
        {
          path: 'inboxes',
          name: 'inbox_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: InboxReports,
        },
        {
          path: 'teams',
          name: 'team_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: TeamReports,
        },
        {
          path: 'sla',
          name: 'sla_reports',
          meta: {
            permissions: ['administrator'],
            featureFlag: FEATURE_FLAGS.SLA,
          },
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta: {
            permissions: ['administrator'],
          },
          component: BotReports,
        },
      ],
    },
  ],
};
